import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {FormGroup, FormBuilder, Validators, AbstractControl, FormControl} from "@angular/forms";
import {FieldsService} from "../shared/model/fields.service";
import {AuthService} from "../shared/security/auth.service";
import {Field} from "../shared/model/field";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-field-detail',
    templateUrl: './field-detail.component.html',
    styleUrls: ['./field-detail.component.css']
})
export class FieldDetailComponent implements OnInit {
    @Input()
    field: Field;

    @Input()
    dbPath: string;

    @Output()
    onChangeDone = new EventEmitter<boolean>();

    myForm: FormGroup;

    $key: string;
    name: string;
    description: string;
    type: string = "football";
    uid: string = "";

    isSaved: boolean = false;
    hasError: boolean = false;
    message: string = "";

    public visibleDetail = false;
    private visibleDetailAnimate = false;

    public types = [
        {value: 'football', display: 'Football'},
        {value: 'tennis', display: 'Tennis'}
    ];

    constructor(private fb: FormBuilder, private fieldsService: FieldsService, private authService: AuthService, private translate: TranslateService ) {
        this.myForm = fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
            'description': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
            'type': ['']
        });
    }

    formDone(done: boolean) {
        this.hide();
        this.onChangeDone.emit(false);  // hide modal add screen
    }

    ngOnInit() {
        //console.log("ngOnInit: FieldDetailComponent");
        //console.log("dbPath: ", this.dbPath);
        this.$key = this.field.$key;
        this.name = this.field.name;
        this.description = this.field.description;
        this.type = this.field.type;

        //this.show();
    }

    ngOnChanges() {
    }

    setFieldType(type: string) {
        this.type = type;
    }

    public show(): void {
        this.visibleDetail = true;
        setTimeout(() => this.visibleDetailAnimate = true);
    }

    public hide(): void {
        this.visibleDetail = false;
        setTimeout(() => this.visibleDetailAnimate = false, 300);
    }

    public save() {
      this.isSaved = true;

      let clubId = this.authService.getClubIdForUser();
      this.fieldsService.updateField(clubId, this.$key, this.name, this.description, this.type);


      this.translate.get('s.fieldedit').subscribe((res: string) => {
        this.message = res;
      });
    }


}
